'use client';
import { Toaster } from 'sonner';

export default function Toast() {
  return (
    <Toaster
      position="bottom-right"
      toastOptions={{
        style: {
          background: '#F5F0E8',
          border: '1px solid #E8E0D0',
          color: '#3D2B1F',
          fontFamily: 'Plus Jakarta Sans, sans-serif',
          fontSize: '14px',
          borderRadius: '12px',
          boxShadow: '0 4px 24px rgba(107,79,58,0.12)',
        },
      }}
    />
  );
}